const configuredBase = (process.env.VUE_APP_API_BASE_URL || '').trim()

function resolveApiBase () {
  if (configuredBase) {
    return configuredBase.replace(/\/+$/, '')
  }

  // 浏览器访问时沿用当前页面的主机名，确保本地开发的会话 Cookie
  // 不会在 localhost 与 127.0.0.1 之间丢失。
  if (typeof window !== 'undefined') {
    return `${window.location.protocol}//${window.location.hostname}:9527`
  }

  // 非浏览器环境的本地默认地址。
  return 'http://127.0.0.1:9527'
}

export const API_BASE = resolveApiBase()
